import {api} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        active: true,
    },
    actions: {
        unlockSettings({}, data) {
            return api.unlock_settings.save(data);
        },
        async checkUserIsUnlocked({rootState,commit}) {
            try {
                const id = rootState.cabinet.user.user_info.data.id
                const res = await api.users_params.get({id, fields: 'unlocked'})
                res.body.data.user.unlocked ? commit('destroyGuard') : commit('activateGuard')
                return res.body.data.user.unlocked;
            } catch (e) {
                throw e
            }
        },
        lockSettings({commit}) {
            commit('activateGuard');
            return api.lock_settings.save();
        }
    },
    mutations: {
        activateGuard(state) {
            state.active = true;
        },
        destroyGuard(state) {
            state.active = false;
        }
    }
}